import { useCallback, useState } from 'react';

const useOpen = <Value = undefined,>(state = false, { stopPropagationOnClick } = { stopPropagationOnClick: false }) => {
  const [open, setIsOpen] = useState(state);
  const [value, setValue] = useState<Value>();
  const onOpen = useCallback(
    (event?: { preventDefault(): void; stopPropagation(): void }) => {
      if (stopPropagationOnClick && event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setIsOpen(true);
    },
    [stopPropagationOnClick],
  );
  const onOpenWithValue = useCallback((...args: [] | [arg1: Value]) => {
    const val = args[0];
    setIsOpen(true);
    setValue(val);
  }, []);
  const onClose = useCallback(() => {
    setIsOpen(false);
    setValue(undefined);
  }, []);

  return { open, onOpen, onClose, value, onOpenWithValue };
};

export default useOpen;
